// extracted by mini-css-extract-plugin
export default {"small__panel":"Slider_small__panel__Dzqxh","slider":"Slider_slider__lcfbq"};